import { types, Instance } from 'mobx-state-tree';
const { model, string, identifierNumber, maybeNull, number, boolean } = types;

export const LogModel = model('LogModel', {
  id: identifierNumber,
  log_name: maybeNull(string),
  description: maybeNull(string),
  event: maybeNull(string),
  subject_id: maybeNull(number),
  subject_type: maybeNull(string),
  causer_id: maybeNull(number),
  causer_type: maybeNull(string),
  is_admin_action: maybeNull(boolean),
  created_at: maybeNull(string),
  // Legacy fields for backward compatibility
  ip: maybeNull(string),
  email: maybeNull(string),
  clientEmail: maybeNull(string),
  type: maybeNull(string),
  additionalData: maybeNull(string),
  createdAt: maybeNull(string),
  eventType: maybeNull(string),
  clientId: maybeNull(number),
  city: maybeNull(string),
  country: maybeNull(string),
  zip_code: maybeNull(string),
  created_by: maybeNull(number),
});

export type ILogModel = Instance<typeof LogModel>;

export const LogsInfoModel = model('LogsInfoModel', {
  name: maybeNull(string),
  lastName: maybeNull(string),
  id: maybeNull(number),
  email: maybeNull(string),
  organizationName: maybeNull(string),
  organizationDomain: maybeNull(string),
  organizationFullDomain: maybeNull(string),
  eduNonProfitGovOrganization: maybeNull(boolean),
  salesTaxGstVatExemptOrganization: maybeNull(boolean),
  password: maybeNull(string),
  imageUrl: maybeNull(string),
});

export type ILogsInfoModel = Instance<typeof LogsInfoModel>;
